import {
  moveToFulfilled,
  moveToPending,
  moveToRejected,
  objectWithoutKeys,
  replaceFulfilled,
} from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { MessageLanguageSpecificContentLoadAction } from '../../domains/messageLanguageSpecificContent/actions.types';
import { getId } from '../../domains/messageLanguageSpecificContent/getId';
import type { PublishEditMessageFulfilledAction } from '../../domains/publishers/actions.types';
import type { Message } from '../types';

import type { MessagesLanguageSpecificContent } from './types';

export type MessageLanguageSpecificContentAction =
  | MessageLanguageSpecificContentLoadAction
  | PublishEditMessageFulfilledAction;

export const initialState: MessagesLanguageSpecificContent = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const invalidateLanguageSpecificContent = (
  state: MessagesLanguageSpecificContent,
  messageId: string,
  messages: Record<string, Message> | undefined
) => {
  const message = messages?.[messageId];
  // istanbul ignore next
  if (!message) {
    return state;
  }

  const keysToInvalidate = Object.keys(state.fulfilled.byId).filter((key) => key.startsWith(messageId));
  const updatedFulfilled = objectWithoutKeys(state.fulfilled.byId, keysToInvalidate);

  return replaceFulfilled(state, updatedFulfilled);
};

const reducer: Reducer<MessagesLanguageSpecificContent, MessageLanguageSpecificContentAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.messagesLanguageSpecificContent);
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_PENDING':
      return moveToPending(state, [getId(action.payload.messageId, action.payload.targetLanguage)]);
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_REJECTED':
      return moveToRejected(
        state,
        [getId(action.payload.messageId, action.payload.targetLanguage)],
        action.payload.error
      );
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return invalidateLanguageSpecificContent(state, action.payload.messageId, action.payload.entities.messages);
    default:
      return state;
  }
};

export default reducer;
